import { extendTheme } from '@chakra-ui/react'

const theme = extendTheme({
  fonts: {
    body: `'Quicksand','Roboto', sans-serif`,
  },
})

export default theme